module.exports = __webpack_public_path__ + "media/images/logo-eb22e0a4a1912485ffc47751b2d0f7fc.svg";